// Content for the landing Workshop studio. Mirrors the real Workshop (backend/routes/workshop.py):
// builds are records with typed fields (text, textarea, number, date, boolean, select, email, phone),
// workflows (when a record is created → condition → notify a role), validation, then Owner-gated publish.
export const STAGES = [
  { id: "describe", name: "Describe", line: "You write what you need, in plain words.",
    explain: "No forms and no code. Brief ARI the way you would brief a colleague." },
  { id: "understand", name: "Understand", line: "ARI restates the goal and asks what it needs to know.",
    explain: "Before anything is designed, ARI confirms who uses the tool, what it tracks and the rules it follows." },
  { id: "design", name: "Design", line: "ARI drafts the records, fields and workflows.",
    explain: "You see the blueprint first. Change anything by simply replying." },
  { id: "build", name: "Build & validate", line: "ARI builds the tool and checks it.",
    explain: "The tool is assembled from the approved design and must pass validation before it can be published." },
  { id: "publish", name: "Publish", line: "The Owner approves and it goes live.",
    explain: "Publishing needs the Owner's permission. Every release is versioned and audited, with a rollback ready." },
];

export const EXAMPLES = [
  {
    id: "swap", prompt: "Build an automated shift-swap flow", title: "Shift Swap",
    understand: ["Staff ask a colleague to cover a shift", "A manager approves or declines", "The team is told once it is approved"],
    questions: ["Can staff swap across different roles?", "Who approves swaps at the weekend?"],
    fields: [["Requested by", "text"], ["Shift date", "date"], ["Covering colleague", "text"], ["Approved", "boolean"], ["Reason", "textarea"]],
    workflow: ["When a swap request is created", "If it is not yet approved", "Notify the manager"],
  },
  {
    id: "waste", prompt: "Log food waste and its cost per shift", title: "Waste Log",
    understand: ["The kitchen logs every wasted item", "Each entry records its cost", "Managers review the totals"],
    questions: ["Which reasons should staff choose from?", "Should costly waste alert a manager?"],
    fields: [["Item", "text"], ["Quantity", "number"], ["Reason", "select"], ["Cost", "number"], ["Date", "date"]],
    workflow: ["When a waste entry is created", "If the cost is over 25", "Notify the manager"],
  },
  {
    id: "opening", prompt: "Create an opening checklist with sign-off", title: "Opening Checklist",
    understand: ["The opening team ticks off each task", "The shift lead signs it off", "Missed tasks are flagged"],
    questions: ["Different lists for weekdays and weekends?", "Who signs off if the lead is away?"],
    fields: [["Task", "text"], ["Completed", "boolean"], ["Completed by", "text"], ["Date", "date"], ["Notes", "textarea"]],
    workflow: ["When a checklist entry is created", "If the task is not completed", "Notify the manager"],
  },
];

export const CHECKS = ["Every record has fields", "Every field has a valid type", "Workflows point to real records"];
